import React, { useMemo } from 'react'

import { PlusOutlined } from '@ant-design/icons'
import { useMerchant } from '@contexts/admin/MerchantContext'
import { useAdminOrderTemplateService } from '@hooks/admin/useAdminOrderTemplateService'
import ListPageHeader from '@shared/ListPageHeader'
import OrderTemplatesList from '@shared/order_templates/OrderTemplatesList'
import { Button } from 'antd'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export default function AdminOrderTemplatesList() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { channels: salesChannels } = useMerchant()

  const orderTemplateService = useAdminOrderTemplateService()

  const salesChannelOptions = useMemo(() => {
    return salesChannels.map(channel => ({
      label: channel.name,
      value: channel.id
    }))
  }, [salesChannels])

  return (
    <div>
      <ListPageHeader
        basePath="/admin"
        items={['orders', 'orders.templates']}
        actions={
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => navigate('/order_templates/new')}
          >
            {t('common.button.new')}
          </Button>
        }
      />
      <OrderTemplatesList
        service={orderTemplateService}
        role="admin"
        salesChannelOptions={salesChannelOptions}
      />
    </div>
  )
}
